export const ZOOM_VALUE_50 = 50;
export const ZOOM_VALUE_60 = 60;
export const ZOOM_VALUE_70 = 70;
export const ZOOM_VALUE_80 = 80;
export const ZOOM_VALUE_90 = 90;
export const ZOOM_VALUE_100 = 100;
export const ZOOM_VALUE_110 = 110;
export const ZOOM_VALUE_120 = 120;
export const ZOOM_VALUE_130 = 130;
export const ZOOM_VALUE_140 = 140;
export const ZOOM_VALUE_150 = 150;
export const ZOOM_VALUE_160 = 160;
export const ZOOM_VALUE_170 = 170;
export const ZOOM_VALUE_180 = 180;
export const ZOOM_VALUE_190 = 190;
export const ZOOM_VALUE_200 = 200;

export const RESOLUTION_ZOOM_1024_768 = [ZOOM_VALUE_80, ZOOM_VALUE_100];
export const RESOLUTION_ZOOM_1152_864 = [ZOOM_VALUE_90, ZOOM_VALUE_120];
export const RESOLUTION_ZOOM_1280_600 = [ZOOM_VALUE_60, ZOOM_VALUE_80];
export const RESOLUTION_ZOOM_1280_720 = [ZOOM_VALUE_70, ZOOM_VALUE_90];
export const RESOLUTION_ZOOM_1280_768 = [ZOOM_VALUE_80, ZOOM_VALUE_100];
export const RESOLUTION_ZOOM_1280_800 = [ZOOM_VALUE_80, ZOOM_VALUE_110];
export const RESOLUTION_ZOOM_1280_966 = [ZOOM_VALUE_100, ZOOM_VALUE_130];
export const RESOLUTION_ZOOM_1280_1024 = [ZOOM_VALUE_100, ZOOM_VALUE_140];
export const RESOLUTION_ZOOM_1360_768 = [ZOOM_VALUE_80, ZOOM_VALUE_100];
export const RESOLUTION_ZOOM_1366_768 = [ZOOM_VALUE_80, ZOOM_VALUE_100];
export const RESOLUTION_ZOOM_1400_1050 = [ZOOM_VALUE_100, ZOOM_VALUE_140];
export const RESOLUTION_ZOOM_1440_900 = [ZOOM_VALUE_80, ZOOM_VALUE_110];
export const RESOLUTION_ZOOM_1536_864 = [ZOOM_VALUE_80, ZOOM_VALUE_110];
export const RESOLUTION_ZOOM_1600_900 = [ZOOM_VALUE_90, ZOOM_VALUE_130];
export const RESOLUTION_ZOOM_1600_1200 = [ZOOM_VALUE_110, ZOOM_VALUE_160];
export const RESOLUTION_ZOOM_1680_1050 = [ZOOM_VALUE_100, ZOOM_VALUE_140];
export const RESOLUTION_ZOOM_1920_1080 = [ZOOM_VALUE_100, ZOOM_VALUE_150];
export const RESOLUTION_ZOOM_DEFAULT = [ZOOM_VALUE_50, ZOOM_VALUE_200];
